import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AttendancesDetailsComponent } from './components/attendances-details/attendances-details.component';
import { AttendancesViewComponent } from './components/attendances-view/attendances-view.component';
import { DefaultComponent } from 'src/app/layouts/default/default.component';



const routes: Routes = [
   {
       path: '', component: DefaultComponent, children: [
        {
            path: '', component: AttendancesDetailsComponent
        },
        {
            path: 'details', component: AttendancesDetailsComponent
        },
        {
            path: 'view/:id', component: AttendancesViewComponent
        }
       ]
   }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AttendancesRoutingModule { }